<template>
  <div class="padding-10">
    <div v-if="cusUser!==undefined" class="card bg-primary color-white padding-10">
      <van-row>
        <van-col span="20">
          <h5>您的余额（{{cusUser.name}}）：</h5>
          <h1>¥ {{cusUser.cash}} 元</h1>
        </van-col>
        <van-col span="4" class="text-right" @click="() => {
          this.chargeWorFlowId = '99571122b00111ec9475afeb8f0a8271'
          this.displayCharges = true
          }"><van-icon name="add-o" size="40" class="margin-tb-20" /></van-col>
      </van-row>
    </div>
    <div v-if="cusCompany!==undefined" class="card bg-warning color-white padding-10 margin-tb-10">
      <van-row>
        <van-col span="20">
          <h5>企业余额（{{cusCompany.name}}）：</h5>
          <h1>¥ {{cusCompany.cash}} 元</h1>
        </van-col>
        <van-col span="4" class="text-right" @click="() => {
          this.chargeWorFlowId = '84c8a200095011ecb5ed27b104feeeaf'
          this.displayCharges = true
          }"><van-icon name="add-o" size="40" class="margin-tb-20" /></van-col>
      </van-row>
    </div>

    <van-popup v-model="displayCharges">
      <div class="padding-10" v-for="salCharge in salCharges" :key="salCharge.id">
        <van-button block type="primary" @click="pay(salCharge.price)">充值¥{{salCharge.price}}元</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Api from '@/utils/api'
import wx from 'weixin-js-sdk'
export default {
  created () {
    Api.post('wei.user/jsapi', {url: window.location.href}, res => {
      let data = res.data
      wx.config({
        debug: false,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ['chooseWXPay']
      })
    })
    Api.post('wei.user/model', null, res => {
      this.weiUser = res.data
      if (res.data.cusUser !== undefined) this.cusUser = res.data.cusUser
      if (res.data.cusCompany !== undefined) this.cusCompany = res.data.cusCompany
    })
    Api.post('sal.charge/models', {page: 1, limit: -1}, res => { this.salCharges = res.data })
  },
  data () {
    return {
      cusUser: undefined,
      cusCompany: undefined,
      weiUser: {},
      salCharges: [],

      chargeWorFlowId: '',
      displayCharges: false
    }
  },
  methods: {
    pay (price) {
      var that = this
      if (this.chargeWorFlowId === '') {
        this.$toast.fail('充值异常')
        return false
      }
      this.displayCharges = false
      let date = new Date()
      let params = {}
      params.wor_flow_id = that.chargeWorFlowId
      params.datas = JSON.stringify({
        business_date: date.getFullYear() + '-' +
          (date.getMonth() >= 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' +
          (date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())),
        price: price,
        remark: '自助充值',
        is_invoice: 1
      })
      if (params.wor_flow_id === '99571122b00111ec9475afeb8f0a8271') {
        params.cus_user_id = this.cusUser.id
        params.ent_company_id = this.cusUser.ent_company_id
      } else if (params.wor_flow_id === '84c8a200095011ecb5ed27b104feeeaf') {
        params.cus_company_id = this.cusCompany.id
        params.ent_company_id = this.cusCompany.ent_company_id
      } else {
        this.$toast.fail('充值异常')
        return false
      }
      wx.ready(function () {
        Api.post('wor.request/create', params, res => {
          Api.post('pay.weixin/index', {wor_request_id: res.data.id}, res => {
            var payWeixin = res.data
            wx.chooseWXPay({
              timestamp: payWeixin.timestamp.toString(),
              nonceStr: payWeixin.noncestr,
              package: payWeixin.package,
              signType: 'MD5',
              paySign: payWeixin.sign,
              success: function (res) {
                // 核对订单支付状态
                Api.post('pay.weixin/model', {id: payWeixin.id}, res => {
                  if (res.is_check === 1) {
                    that.$toast.success('支付成功')
                  } else {
                    that.$toast.fail('支付异常')
                  }
                  that.reload()
                })
              },
              cancel: function (res) {
                console.log(res)
                that.$toast.fail('取消支付')
              },
              fail: function (res) {
                console.log(res)
                that.$toast.fail('支付失败')
              }
            })
          })
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Wallet.vue